import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  formSection: {
    paddingBottom: '10px'
  }
}));

const OlnStateFilter = props => {
  const classes = useStyles();

  const handleFilterOlnStateChange = event => {
    props.setSelectedOlnState(event.target.value);
  };

  return (
    <FormControl fullWidth variant="outlined" className={classes.formSection}>
      <InputLabel id="filter-status">OLN State</InputLabel>
      <Select
        labelId="plate-state"
        value={props.selectedOlnState}
        onChange={handleFilterOlnStateChange}>
        <MenuItem value=""> </MenuItem>
        {props.states.map((state, idx) => (
          <MenuItem value={state.Code} key={idx}>
            {state.Description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OlnStateFilter;
